/**
 * Liste des champs obligatoires pour une entreprise
 */
export const CORPORATION_REQUIRED_FIELDS = [
  "name", // Raison sociale
  "registration", // Siren
  "registrationCountryCode", // Pays d'imamtriculation
  "activityCode", // Activité
  "entityTypeCode", // Type juridique
  "customListCode2", // Forme juridique
  "customString1", // Code postal + ville du siège social
  "customString2", // Numéro et rue du siège social
  "customCountryCode1", // Pays du siège social
] as const;

/**
 * Type pour les champs requis d'une entreprise
 */
export type CorporationRequiredField = (typeof CORPORATION_REQUIRED_FIELDS)[number];
